import React from 'react';

export const ProductLoader: React.FC = React.memo(() => {
    return <React.Fragment></React.Fragment>;
});
